import * as XLSX from 'xlsx';

export const downloadPaymentBatchExcel = ({ batch, bankSummary = [], payments, businessUnitName }) => {
  if (!batch || !payments?.length) return;

  const summaryRows = [
    ['Payment Batch Export'],
    [],
    ['Batch Number', batch.batchNumber || ''],
    ['Payment Date', batch.paymentDate || ''],
    ['Bank', batch.bankName || ''],
    ['Payment Method', batch.paymentMethod || ''],
    ['Total Amount', batch.totalAmount ?? ''],
    ['Batch Status', batch.batchStatus || ''],
    ...(businessUnitName ? [['Business Unit', businessUnitName]] : []),
    ['Payment Count', payments.length],
    ['Bank Count', batch.bankCount ?? ''],
    ['Vendor Count', batch.vendorCount ?? ''],
  ];

  const bankHeader = ['Vendor', 'Bank', 'Payment Method', 'Payments', 'Amount'];
  const bankRows = (bankSummary || []).map((row) => [
    row.vendorName || '',
    row.bankName || '',
    row.paymentMethods || '',
    row.paymentCount ?? '',
    row.totalAmount ?? '',
  ]);

  const paymentHeader = [
    'Invoice Number',
    'Vendor',
    'Invoice Amount',
    'Prior Paid',
    'Payment Amount',
    'Remaining Balance',
    'Bank',
    'Payment Method',
    'Payment Reference',
  ];

  const paymentRows = payments.map((row) => [
    row.invoiceNumber,
    row.vendorName,
    row.amount,
    row.paidAmount,
    row.paymentAmount,
    row.remainingBalance,
    row.bankName || '',
    row.paymentMethod,
    row.paymentReference,
  ]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(summaryRows), 'Batch Summary');

  if (bankRows.length) {
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet([bankHeader, ...bankRows]),
      'Bank Summary'
    );
  }

  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet([paymentHeader, ...paymentRows]),
    'Payments'
  );

  const safeName = String(batch.batchNumber || 'payment-batch').replace(/[^\w-]/g, '_');
  XLSX.writeFile(workbook, `${safeName}.xlsx`);
};
